import { jsxs, jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import { Spinner } from '../Spinner/Spinner.js';

function IntroVideo({
  video,
  videoSrc,
  className
}) {
  const {
    videoRef,
    isLoading,
    toggleMute,
    videoProps
  } = video;
  return jsxs("div", {
    className: clsx('relative cursor-pointer overflow-hidden rounded border border-solid border-gray', className),
    role: "button",
    tabIndex: 0,
    onClick: toggleMute,
    onKeyDown: e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggleMute();
      }
    },
    onMouseEnter: () => {
      const isDesktop = window.matchMedia('(min-width: 768px)').matches;
      if (isDesktop && videoRef.current) videoRef.current.controls = true;
    },
    onMouseLeave: () => {
      if (videoRef.current) videoRef.current.controls = false;
    },
    children: [jsx("video", {
      ref: videoRef,
      className: "block min-h-[180px] w-full",
      src: videoSrc,
      preload: "auto",
      muted: true,
      playsInline: true,
      ...videoProps
    }), isLoading && jsx(Spinner, {})]
  });
}

export { IntroVideo };
